import { commonParams } from 'common/config/config'
import {
  creatHttpTool,
  creatCustomHttpTool,
  creatCustomHttpToolData,
} from 'common/js/httpTool'

import HomeWork from 'homework/model/homework'
import UGlobalService from 'common/js/UGlobalService'

import {
  loadJs
} from 'common/utils/common'
import {
  handleFormatDate
} from 'common/js/date'
// import { formatTextarea, unformatTextarea } from 'common/utils/common.js'

const lang = window.getLang()

let httpTool = creatHttpTool()
let customHttpTool = creatCustomHttpTool()
let customHttpToolData = creatCustomHttpToolData()
let global = () => {
  return UGlobalService.getGlobal()
}

export function saveHomewrok (data, success, failure) {
  //   提交作业的请求
  data.ocId = global().ocId
  data.lang = lang
  return httpTool.post('/teaHomework/assignHomeWork', data).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function getGradeByYear (userID, success, failure) {
  let url = '/teaHomework/getClassListOrderByYear/' + userID + '/-1'
  if (parseInt(global().ocId) > 0) {
    url = '/teaHomework/getClassListOrderByYear/' + userID + '/' + global().ocId
  }
  return httpTool.get(url).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}
export function getGradeByTeacher (userID, teacherId, searchStr, homeworkID, success, failure) {
  let url = '/teaHomework/getClassListByTeacher/' + userID + '/' + teacherId + '/-1'
  if (parseInt(global().ocId) > 0) {
    url = '/teaHomework/getClassListByTeacher/' + userID + '/' + teacherId + '/' + global().ocId
  }
  url += '?className=' + searchStr + (homeworkID ? '&homeworkID=' + homeworkID : '')
  return httpTool.get(url).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function gerGradeStudentList (classId = -1, teacherId = -1, homeWorkID, order = 0, success, failure) {
  let url = `/teaHomework/getStudentList/${homeWorkID}/${classId}/${teacherId}/${order}`
  return httpTool.get(url).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}
export function getCreateWorkDetail (param, success, failure) {
  return httpTool.get('/homework/previewHomework/' + param + '/' + global().ocId).then(function (res) {
    try {
      res.activityHomework.startTime = handleFormatDate(res.activityHomework.startTime)
      res.activityHomework.endTime = handleFormatDate(res.activityHomework.endTime)
      res.activityHomework.peerReviewTime = handleFormatDate(res.activityHomework.peerReviewTime)
      res.activityHomework.lateShipmentTime = handleFormatDate(res.activityHomework.lateShipmentTime)
    } catch (error) {
      console.log(error)
    }
    let model = new HomeWork(res.activityHomework)
    let classModels = res.classModels
    let allClasses = []
    if (Array.isArray(classModels)) {
      classModels.forEach(function (classModel) {
        allClasses.push({
          'classname': classModel.classname, // 后台需要的字段的和传给前端的字段名不一样，与原来前端显示需要的又不一样，所以加上了两个
          'className': classModel.classname,
          'classID': classModel.classid, // 后台需要的字段的和传给前端的字段名不一样，与原来前端显示需要的又不一样，所以加上了两个
          'classId': classModel.classid,
          'startTime': handleFormatDate(classModel.startTime),
          'isEndTime': classModel.isEndTime,
          'endTime': handleFormatDate(classModel.endTime),
          'peerReviewTime': handleFormatDate(classModel.peerReviewTime)
        })
      })
    }
    model.selectClass = allClasses
    model.hasStuSubmit = res.hasStuSubmit

    success && success(model, allClasses)
  }, function (e) {
    failure && failure(e)
  })
}

export function getStudentHomeworkList (params, success, failure) {
  let param = {
    userID: params.userID,
    homeworkID: params.homeworkID,
    classID: params.classID || -1,
    status: params.status,
    order: params.order || 3,
    start: params.start || 0,
    teacherID: params.teacherID || params.userID,
    keyValue: params.keyValue || ''
  }
  return httpTool.get(`/teaHomework/studentHomeworkList/${param.userID}/${param.teacherID}/${param.homeworkID}/${param.classID}/${param.status}/${param.order}/${param.start}/${global().ocId}?keyword=${param.keyValue}`).then(function (res) {
    try {
      res.activityHomework.startTime = handleFormatDate(res.activityHomework.startTime)
      res.activityHomework.endTime = handleFormatDate(res.activityHomework.endTime)
      res.activityHomework.peerReviewTime = handleFormatDate(res.activityHomework.peerReviewTime)
      res.activityHomework.lateShipmentTime = handleFormatDate(res.activityHomework.lateShipmentTime)
      for (var i = 0; i < res.datalList.length; i++) {
        var data = res.datalList[i]
        if (data.studentHomework) {
          data.studentHomework.createTime = handleFormatDate(data.studentHomework.createTime)
          data.studentHomework.updateTime = handleFormatDate(data.studentHomework.updateTime)
        }
      }
    } catch (error) {
      console.log(error)
    }

    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function getstuHomeworkDetail (teaid, homeworkID, userID, success, failure) {
  return httpTool.get(`/teaHomework/studentHomeworkDetail/${teaid}/${homeworkID}/${userID}/${global().ocId}`).then(function (res) {
    try {
      res.activityHomework.startTime = handleFormatDate(res.activityHomework.startTime)
      res.activityHomework.endTime = handleFormatDate(res.activityHomework.endTime)
      res.activityHomework.peerReviewTime = handleFormatDate(res.activityHomework.peerReviewTime)
      res.studentHomework.updateTime = handleFormatDate(res.studentHomework.updateTime)
      res.studentHomework.evaluationTime = handleFormatDate(res.studentHomework.evaluationTime)
    } catch (error) {
      console.log(error)
    }
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function getstuHomeworkDetailV2 (stuid, success, failure) {
  return httpTool.get(`/teaHomework/getDetailById/${stuid}`).then(function (res) {
    try {
      res.activityHomework.startTime = handleFormatDate(res.activityHomework.startTime)
      res.activityHomework.endTime = handleFormatDate(res.activityHomework.endTime)
      res.activityHomework.peerReviewTime = handleFormatDate(res.activityHomework.peerReviewTime)
      res.studentHomework.updateTime = handleFormatDate(res.studentHomework.updateTime)
      res.studentHomework.evaluationTime = handleFormatDate(res.studentHomework.evaluationTime)
    } catch (error) {
      console.log(error)
    }
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}
export function getStudentHomeworkListByNameOrID (homeworkID, searchText, success, failure) {
  let params = {
    homeworkID: homeworkID,
    nameOrStudentID: searchText,
    ocId: global().ocId
  }
  return httpTool.post('/teaHomework/selectStudentHomework', params).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function getHistroystuHomeworkDetail (userID, stuUserID, homeworkID, success, failure) {
  return httpTool.get(`/homework/historyStudentHomework/${userID}/${stuUserID}/${homeworkID}`).then(function (res) {
    try {
      for (let i = 0; res.studentHomeworkList && i < res.studentHomeworkList.length; i++) {
        res.studentHomeworkList[i].updateTime = handleFormatDate(res.studentHomeworkList[i].updateTime)
        res.studentHomeworkList[i].evaluationTime = handleFormatDate(res.studentHomeworkList[i].evaluationTime)
      }
    } catch (error) {
      console.log(error)
    }
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function saveGradingHomework (data, success, failure) {
  //   提交作业的请求
  data.lang = lang
  return httpTool.post('/teaHomework/correctHomework', data).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

// 学生提交作业
export function saveHomeworkByStu (data, success, failure) {
  return httpTool.post('/stuHomework/saveHomework', data).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

// 学生查重
export function saveDuplicate (userID, homeworkID, content, success, failure) {
  let model = {
    userID: userID,
    homeworkID: homeworkID,
    content: content
  }
  return httpTool.post('/stuHomework/getDuplicate', model).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(!e ? '网络错误，请稍后重试' : e)
  })
}

export function getStuDetailOfHome (userID, homeworkID, success, failure) {
  return httpTool.get(`/stuHomework/homeworkDetail/${homeworkID}/${userID}/${global().ocId}`).then(function (res) {
    try {
      res.activityHomework.startTime = handleFormatDate(res.activityHomework.startTime)
      res.activityHomework.endTime = handleFormatDate(res.activityHomework.endTime)
      res.activityHomework.peerReviewTime = handleFormatDate(res.activityHomework.peerReviewTime)
      res.activityHomework.lateShipmentTime = handleFormatDate(res.activityHomework.lateShipmentTime)
      res.studentHomework.updateTime = handleFormatDate(res.studentHomework.updateTime)
      res.studentHomework.evaluationTime = handleFormatDate(res.studentHomework.evaluationTime)
      res.lateShipment = handleFormatDate(res.lateShipment)
      res.rewriteTime = handleFormatDate(res.rewriteTime)
    } catch (error) {
      console.log(error)
    }

    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

// 学生检测语法
export function saveSyntaxChecking (userID, homeworkID, content, success, failure) {
  let model = {
    userID: userID,
    homeworkID: homeworkID,
    content: content
  }
  return httpTool.post('/stuHomework/syntaxChecking', model).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

// 学生检测语法
export function addHomeworkRule (rules, success, failure) {
  let model = {
    'peerReviewHomeworkRuleList': rules
  }
  return httpTool.post('/teaHomework/peerReviewHomeworkRule', model).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

// 评价任务
export function getPeerTask (homeworkID, userID, success, failure) {
  return httpTool.get(`/stuHomework/peerReviewHomeworkDatil/${homeworkID}/${userID}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

export function getShareWorkList (userID, homeworkID, success, failure) {
  return httpTool.get(`/homework/shareStudentHomework/${homeworkID}/${userID}/${global().ocId}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure()
  })
}

// 驳回申诉
export function rejectPeer (studentHomeworkID, teacherID, success, failure) {
  return httpTool.get(`/teaHomework/rejectHomework/${teacherID}/${studentHomeworkID}`).then(function (res) {
    success && success(res)
  }, function () {
    failure && failure()
  })
}

// 学生批阅互评作业
export function savePeerReview (data, success, failure) {
  return httpTool.post('/stuHomework/savePeerReview', data).then(function (res) {
    success && success(res)
  }, function (res) {
    failure && failure(res)
  })
}

export function deleteHomework (userID, homeworkID, success, failure) {
  return httpTool.delete(`/teaHomework/deleteHomework/${userID}/${homeworkID}/${global().ocId}`).then(function (res) {
    success && success(res)
  }, function () {
    failure && failure()
  })
}

// 删除互评规则
export function deleteHomeworkRule (homeworkID, success, failure) {
  return httpTool.delete(`/teaHomework/peerReviewHomeworkRule/${homeworkID}`).then(function (res) {
    success && success(res)
  }, function () {
    failure && failure()
  })
}
// 获取互评规则
export function getHomeworkRules (homeworkID, success, failure) {
  return httpTool.get(`/teaHomework/peerReviewHomeworkRule/${homeworkID}`).then(function (res) {
    success && success(res)
  }, function () {
    failure && failure()
  })
}
export function getHomeworkPoint (userID, keyword, success, failure) {
  return httpTool.get(`/teaHomework/getRecentlyScoringPoint/${userID}?keyword=${keyword}`).then(function (res) {
    success && success(res)
  }, function () {
    failure && failure()
  })
}
//  学生申诉
export function complainHomework (data, success, failure) {
  return httpTool.post('/stuHomework/complainHomework', data).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

// 获取查重报告eee
export function getDuplicateReport (userID, homeworkID, stuUserID, success, failure) {
  return httpTool.get(`/teaHomework/getDuplicateRateContent/${userID}/${homeworkID}/${stuUserID}`).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

// l图片转换 base64
export function convertBase64 (data, success, failure) {
  return httpTool.post('/teaHomework/base64ImgConvert', data).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

// 上传base64 token
export function getUpToken (param, success, failure) {
  return httpTool.getToken(param).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

// 上传base64 get url
export function saveBase64Img (url, cusstParam, param, success, failure) {
  return customHttpTool.post(url, cusstParam, param).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

//    老师端的提醒 交作业
export function remindCommitHomework (homeworkID, classID, success, failure) {
  return httpTool.get(`/teaHomework/remindCommitHomework/${homeworkID}/${global().ocId}/${classID}`).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

// 修改最后提交时间
export function updateLateShipmentTime (params, success, failure) {
  let path = `/teaHomework/updateLateShipmentTime/${params.userID}/${params.homeworkID}/${params.lateShipTime}/${params.classID}`
  if (params.lateShipmentEndTime) {
    path = path + '?lateShipmentEndTime=' + params.lateShipmentEndTime
  }
  return httpTool.get(path).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}
/*
 * 获取课程角色
 * */
export function getCourseRole (url, ocId, success, failure) {
  return httpTool.getOwn(`${url}/users/role/${ocId}`).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}
// 转换文档 、视频
export function convertFile (url, param, success, failure) {
  return httpTool.convertFile(`${url}/${param}`).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

export function getResUpToken (url, success, failure) {
  return httpTool.getToken(`${url}`).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

export function getFile (url, success, failure) {
  return customHttpTool.get(`${url}`).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}


export function teacherTeam (params, success, failure) {
  let path = `/groupHomework/teacherTeam?ocId=${params.ocId}&homeworkId=${params.homeworkID}`
  return httpTool.get(path).then(function (res) {
    console.log("teacherTeam",res);
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

export function batchMark (data, success, failure) {
  let path = `/teaHomework/batchMark/${data.homeworkId}/${data.ocId}/${data.teacherId}`
  return httpTool.post(path,data).then(function (res) {
    success && success(res)
  }, function (err) {
    failure && failure(err)
  })
}

export function setUpMathMax (markwrapid) {
  loadJs('https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_SVG', function () {
    try {
      window.MathJax.Hub.Config({
        tex2jax: {
          inlineMath: [
            ['\\(', '\\)']
          ],
          displayMath: [
            ['\\[', '\\]']
          ],
          processEscapes: true,
          skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code', 'a'],
          ignoreClass: 'formulaTextarea'
        },
        TeX: {
          extensions: ['mhchem.js']
        },
        showMathMenu: false,
        showMathMenuMSIE: false
      })
    } catch (e) {

    }
    try {
      window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, markwrapid])
    } catch (e) {

    }
  })
}

//mode1 启动转图片的任务； 2 获取文档转图片的结果
export function getDocToImagesStatus (params, success, failure) {
  return httpTool.get(`/doc/annotation/statusAndPictures?relationType=9&relationId=${params.relationId}&mode=${params.mode}&fileUrl=${params.fileUrl}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure()
  })
}

//文档批注保存 /doc/annotation
export function saveDocMark (params, success, failure) {
  return httpTool.post(`/doc/annotation?relationType=9&relationId=${params.relationId}&fileUrl=${params.fileUrl}`, params.pictureDTOList).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

//删除文档全部批注
export function deleteDocMarks (params, success, failure) {
  return httpTool.delete(`/doc/annotation?relationType=9&relationId=${params.relationId}&fileUrl=${params.fileUrl}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}

// 获取带有批注的文档地址
export function getMarkedDocUrl (params, success, failure) {
  return httpTool.get(`/doc/annotation/exportPdfUrl?relationType=9&relationId=${params.relationId}&fileUrl=${params.fileUrl}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure()
  })
}

// 个人作业按学生导出查询列表（优良中差）
export function getStuHomeListByLevel (params, success, failure) {
  return httpTool.get(`/teaHomework/studentHomeworkListByLevel?classId=${params.classId}&homeworkId=${params.homeworkId}&keyword=${params.keyword}&level=${params.level}&ocId=${params.ocId}&start=${params.start}&teacherId=${params.teacherId}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure()
  })
}

// 
export function getAiMark (params, success, failure) {
  return customHttpToolData.get(`${commonParams.COURSE_API_HOST}/users/menu/hasMenuByCode?code=homeworkMark&userId=${params.userId}`).then(function (res) {
    success && success(res)
  }, function (e) {
    failure && failure(e)
  })
}


// WEBPACK FOOTER //
// ./src/module/homework/api/hwApi.js